import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import ClusterIconMenu from '@shell/components/ClusterIconMenu.vue';
import { abbreviateClusterName, clusterChip } from '@shell/utils/cluster';

interface Props {
  row: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterBadgeIcon',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);

const cluster = computed(() => clusterChip(props.row));

// The chip is the cell's only content, so without a name the column reads as empty cells.
const label = computed(() => {
  const { badge, isLocal, label: name } = cluster.value;
  const text = badge?.iconText || (isLocal ? '' : abbreviateClusterName(name));

  // The chip draws its text uppercase.
  return text ? text.toUpperCase() : t('nav.ariaLabel.localClusterIcon');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ClusterIconMenu, {
    cluster: cluster.value,
    "show-pin": false,
    class: "cluster-badge-icon",
    role: "img",
    "aria-label": label.value
  }, null, 8, ["cluster", "aria-label"]))
}
}

})